import * as RadixTooltip from '@radix-ui/react-tooltip';
import styled, { css } from 'styled-components/macro';
import { BaseContent, BaseScrollArea } from '../_core/overlay/overlay.styled';
import {
  overlaySlideInBottom,
  overlaySlideInLeft,
  overlaySlideInRight,
  overlaySlideInTop,
  overlaySlideOutBottom,
  overlaySlideOutLeft,
  overlaySlideOutRight,
  overlaySlideOutTop,
} from '../_core/overlay/overlay.animations';

export const TooltipContent = styled(RadixTooltip.Content)`
  ${({ theme }) => css`
    ${BaseContent};
    z-index: 9999;
    min-width: unset;
    width: fit-content;
    max-width: min(var(--radix-tooltip-content-available-width), 300px);
    max-height: var(--radix-tooltip-content-available-height);
    border-radius: ${theme.radiuses.xxs};
    background-color: ${theme.semantic.bg.inverse};
    color: ${theme.semantic.text.onInverse};
    box-shadow: none;
    border: none;
    transform-origin: var(--radix-tooltip-content-transform-origin);
    word-break: break-word;

    &[data-state='delayed-open'] {
      &[data-side='top'] {
        animation-name: ${overlaySlideInTop};
      }
      &[data-side='right'] {
        animation-name: ${overlaySlideInRight};
      }
      &[data-side='bottom'] {
        animation-name: ${overlaySlideInBottom};
      }
      &[data-side='left'] {
        animation-name: ${overlaySlideInLeft};
      }
    }

    &[data-state='closed'] {
      &[data-side='top'] {
        animation-name: ${overlaySlideOutTop};
      }
      &[data-side='right'] {
        animation-name: ${overlaySlideOutRight};
      }
      &[data-side='bottom'] {
        animation-name: ${overlaySlideOutBottom};
      }
      &[data-side='left'] {
        animation-name: ${overlaySlideOutLeft};
      }
    }

    .tooltip-arrow {
      fill: ${theme.semantic.bg.inverse};
    }
  `};
`;

export const ScrollArea = styled.div`
  ${BaseScrollArea};
`;
